import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { setAuthed } from "../features/account/accountSlice";
import { useDispatch } from "../hooks";
import { API } from "../services/api";

export default function useLogout() {
    const navigate = useNavigate();

    const dispatch = useDispatch();

    const logout = (redirect?: string) => {
        Cookies.remove("cs_infoviewer_auth");
        dispatch(API.util.resetApiState());
        dispatch(setAuthed(false));
        if (redirect) {
            navigate(redirect);
        }
    };

    return logout;
}
